import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { dailySessionNotes } from '../../actions/constant';
import dailySessionNotesService from 'src/services/apiServices/dailySessionNotes/dailySessionNotes';
const {
  UPDATE_DAILY_SESSION_NOTES_FAILURE,
  UPDATE_DAILY_SESSION_NOTES_REQUEST,
  UPDATE_DAILY_SESSION_NOTES_SUCCESS,
} = dailySessionNotes;

function* updateDailySessionNotes(payload: any): SagaReturnType<any> {
  try {
    const response = yield call(dailySessionNotesService.updateDailySessionNotes, payload?.payload);
    if (response?.status === 200) {
      yield put({ type: UPDATE_DAILY_SESSION_NOTES_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: UPDATE_DAILY_SESSION_NOTES_FAILURE, payload: error });
  }
}

function* updateDailySessionNotesSaga() {
  yield takeEvery(UPDATE_DAILY_SESSION_NOTES_REQUEST, updateDailySessionNotes);
}

export default updateDailySessionNotesSaga;
